import React from "react";
import { useHistory } from "react-router-dom";
import SuccessDialog from "./SuccessDialog";
import { Typography, useTheme } from "@mui/material";
import { insuranceCoverageDetailsStyle } from "./customstyles/DashboardStyle";
const useStyles = () => {
  const theme = useTheme();
  return insuranceCoverageDetailsStyle(theme);
};
function LogOutDialog({ setShowLogoutDialog, logout }) {
  const styles = useStyles();
  const loginBy = localStorage.getItem("loginBy");
  const navigate = useHistory();
  return (
    <SuccessDialog
      HeaderText={
        <Typography sx={styles.dialogHeading}>End AIMS session?</Typography>
      }
      successButton={[
        <Typography
          onClick={() => setShowLogoutDialog(false)}
          sx={styles.dialogbtnStyle}
        >
          Cancel
        </Typography>,
        <Typography
          key={"logout-button"}
          onClick={async () => {
            await logout();
            setShowLogoutDialog(false);
            if (loginBy === "sso") {
              navigate.replace("/logout");
            } else {
              navigate.replace("/login");
            }
          }}
          sx={styles.dialogbtnStyle}
        >
          Log Out
        </Typography>,
      ]}
      BodyText={
        loginBy === "sso" ? (
          <Typography sx={styles.dialogBodytext}>
            Are you sure you want to end this session? You may re-open AIMS
            again through any patient’s record in your EHR.
          </Typography>
        ) : (
          <Typography sx={styles.dialogBodytext}>
            Are you sure you want to end this session? You will need to log in
            to AIMS again with another OTP (one-time password).
          </Typography>
        )
      }
      dismiss={""}
    />
  );
}
export default LogOutDialog;
